// extracted by mini-css-extract-plugin
module.exports = {"ZHComp":"ZH_ZHComp__c3m3W"};